import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "./routes/AppRoutes";
import ConsentBanner from "./components/Consent/ConsentBanner";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import useUrlLanguageDetector from "./hooks/useUrlLanguageDetector";
import "./assets/styles/global.scss";

function AppContent() {
  useUrlLanguageDetector();

  return (
    <>
      <ScrollToTop />
      <AppRoutes />
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppContent />
        <ConsentBanner />
      </Router>
    </HelmetProvider>
  );
}

export default App;
